import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { PostRequest } from "../../services/ApiClientService"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { ERequestType } from "../../Enum/ERequestType"
import { useTranslation } from "react-i18next"

export const useAdminEmployeePermissions = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleUpdatePermissions = async (id: number, permissions: string[], onSuccess: () => void) => {
    enableLoad()

    try {
      const response = await PostRequest(API_ROUTES.ADMIN_EMPLOYEE.RULES(id), { permissions }, ERequestType.Admin)

      if (response.success) {
        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return { handleUpdatePermissions }
}
